import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Controller, Scene } from 'react-scrollmagic';

import MainVideo from './components/MainVideo';
import Gallery from './components/Gallery';
import Values from './components/Values';
import AskYourself from './components/AskYourself';
import OurValues from './components/OurValues';
import Branding from './components/Branding';
import WearCollection from './components/WearCollection';
import Care from './components/Care';
import Feedback from './components/Feedback';
import Footer from './components/Footer';

import { setScreen } from './actions/screen';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      textVisible: true,
      blockVideo: true,
    }
  }

  componentDidMount() {
    this.props.setScreen();

    window.addEventListener('resize', this.updateScreen.bind(this));
  }

  updateScreen() {
    this.props.setScreen();
  }

  hideTextVideo() {
    this.setState({
      textVisible: false,
      blockVideo: false,
    })
  }

  showTextVideo() {
    this.setState({
      textVisible: true,
      blockVideo: true,
    })
  }

  render() {
    return(
      <div className="App">
        <Controller>
          <Scene duration={1200} pushFollowers={false} pin triggerHook="onLeave">
            {
              (progress) => {
                progress > 0.1 && this.state.textVisible && this.hideTextVideo.call(this);
                progress < 0.1 && !this.state.textVisible && this.showTextVideo.call(this);

                return(
                  <div>
                    <MainVideo textVisible={this.state.textVisible}/>
                  </div>
                )
              }
            }
          </Scene>
          <Gallery />
          <Values />
          <AskYourself />
          <OurValues />
          <Branding />
          <Scene duration={5000} pin triggerHook="onLeave">
            {
              (progress, eventParams) => (
                <div>
                  <WearCollection
                    progress={progress}
                    eventParams={eventParams}
                  />
                </div>
              )
            }
          </Scene>
          <Care />
          <Feedback />
          <Footer />
        </Controller>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    screen: state.screen.screen,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  setScreen,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);